var map = {
	"./10-12-2020-v2/1024/img/Tail_feathers_MetalRoughness.jpg": "4154",
	"./10-12-2020-v2/2048/img/Tail_feathers_MetalRoughness.jpg": "f65a",
	"./10-12-2020-v2/512/img/Tail_feathers_MetalRoughness.jpg": "bbe8",
	"./10-12-2020-v3/1024/img/Tail_feathers_MetalRoughness.jpg": "63e0",
	"./10-12-2020-v3/2048/img/Tail_feathers_MetalRoughness.jpg": "f3a4",
	"./10-12-2020-v3/512/img/Tail_feathers_MetalRoughness.jpg": "0e06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf68";